import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { SidePanelBase } from '../../../common/components/side-panel-base.class';
import { SidePanelService } from '../../../common/services/side-panel.service';

@Component({
    selector: 'app-add-link',
    templateUrl: './add-link.component.html',
    standalone: false
})
export class AddLinkComponent extends SidePanelBase implements OnInit {

  static componentName = 'AddLinkComponent';



  @ViewChild('form', { static: true }) form: any;
  linkForm: FormGroup;
  linkRoute: string = '';
    linkText: string = '';
    permission: string = "";
  showError: boolean = false;

  constructor(public _sidePanelService: SidePanelService,
              public _formBuilder: FormBuilder) {
    super();
  }

  ngOnInit() {
  }

  cancel(): void {
    this.form.reset();
    this._sidePanelService.toggleSidePanel(false);
  }

  save(): void {
    this.saveMethod.emit({
      title: this.linkText,
      route: this.linkRoute,
      moduleGroupId: this.componentData.moduleGroupId,
      moduleId: this.componentData.module.id,
      permission: this.permission
    });
    
    this.form.reset();
    this._sidePanelService.toggleSidePanel(false);
  }

}
